import React from 'react';

interface Props {
  children: React.ReactNode;
}

// Always returns true; gate is fully bypassed
function isUnlocked(): boolean {
  return true;
}

export default function PasswordGate({ children }: Props): React.JSX.Element {
  // Instantly render children, skipping all gating logic, input fields, and storage
  return <>{children}</>;
}
